import { FormStore, useStoreState } from '@ariakit/react'
import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import {
  B2bLogoAndTextFormValues,
  TextFormValues,
} from '../../../../../../containers/EmbroideryContainer/types'
import { EmbroideryColor } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { ColorSelector } from '../../../../Modal/primitives/selectors/ColorSelector/ColorSelector'
import { EmbroideryOptionWrapper } from '../../../../Modal/primitives/shared-form-styles'

interface Props {
  form: FormStore<TextFormValues | B2bLogoAndTextFormValues>
  colorRestrictions: { key: string }[] | null | undefined
  disabled?: boolean
  productColorHex: string | undefined
}

export const NameColor: FC<Props> = ({ form, colorRestrictions, disabled, productColorHex }) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const textColor = useStoreState(form, s => s.values.textColor)
  const errorMessage = useStoreState(form, () =>
    form.getFieldTouched('textColor') ? form.getError('textColor') : undefined
  )

  const handleSelectColor = (colorName: EmbroideryColor) => form.setValue('textColor', colorName)

  return (
    <EmbroideryOptionWrapper>
      <ColorSelector
        errorMessage={errorMessage ?? undefined}
        onSelectColor={handleSelectColor}
        selectedColor={textColor}
        label={fixtures.textOption.textColorLabel}
        colorRestrictions={colorRestrictions}
        disabled={disabled}
        productColorHex={productColorHex}
      />
    </EmbroideryOptionWrapper>
  )
}
